import { render, staticRenderFns } from "./BannerEmpresa.vue?vue&type=template&id=28d1982c&lang=pug&"
import script from "./BannerEmpresa.vue?vue&type=script&lang=js&"
export * from "./BannerEmpresa.vue?vue&type=script&lang=js&"
import style0 from "./BannerEmpresa.vue?vue&type=style&index=0&id=28d1982c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports